'use client';

import {useState} from 'react';
import dynamic from 'next/dynamic';
import {IconHelpSquareRounded} from '@tabler/icons-react';
import NavButtons, {type NavButtonProps} from '../navigation/NavButtons';
import {addCircleLine} from 'src/utils/icons';
import useUser from 'src/hooks/useUser';

const AuthModal = dynamic(() => import('../auth/AuthModal'));

const QuizNavButtons = () => {
  const {user} = useUser();

  const [isJoinModalOpen, setIsJoinModalOpen] = useState(false);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);

  const navButtons: NavButtonProps[] = [
    user ? {label: 'Create', href: '/quiz/create', icon: addCircleLine, isVisible: true} : null,
    user
      ? {
          label: 'My quizzes',
          href: `/quiz/users/${user.nameId}`,
          TablerIcon: IconHelpSquareRounded,
          isVisible: true
        }
      : null,
    !user ? {label: 'Join', onPress: () => setIsJoinModalOpen(true), icon: addCircleLine, isVisible: true} : null
  ].filter(Boolean);

  return (
    <>
      <NavButtons items={navButtons} />
      {user ? null : (
        <>
          <AuthModal initialView="join" isOpen={isJoinModalOpen} setIsOpen={setIsJoinModalOpen} />
          <AuthModal initialView="login" isOpen={isLoginModalOpen} setIsOpen={setIsLoginModalOpen} />
        </>
      )}
    </>
  );
};

export default QuizNavButtons;
